"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cittiglio": {
    "c4c58b72": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-pirla": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60fa7d62": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "cascate-di-san-giulio": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fe994b80": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "cascine": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5da006b9": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "casere": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "70a4f140": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "cereda": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "73d86374": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "chiosi": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a9c97dc": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "cormeta": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45b40a41": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "fracce": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3189379": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "ghetto": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d5eee1b0": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "la-fontanaccia": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fd7a0c74": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "le-ville": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46a5a2c6": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "molinazzo": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aad31499": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-la-tegia": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "14e334c9": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "mulini": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6116e76d": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "passo-barbe": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6866d202": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "passo-del-cuvignone": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bb644412": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "pianazzo": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5fdd8b21": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "pizzoni-di-laveno": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b3e7f34": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "skipSearch": false
    }],
    "sasso-del-ferro": [{
      "hkey": "0f4f6f2d",
      "slug": "cittiglio",
      "name": "Cittiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;